import { Injectable } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { BehaviorSubject, fromEvent, Observable, Subscription } from 'rxjs';
import { AppNotificationService } from './notification.service';
import { AppComponent } from 'src/app/app.component';

@Injectable({
  providedIn: 'root'
})
export class ConnectivityStateService {

  constructor(
    private appNotificationService: AppNotificationService
  ) { this.handleAppConnectivityChanges()}

  private _connectionState$ = new BehaviorSubject<boolean>(false);
  public connectionState$ = this._connectionState$.asObservable();

  //Common connectivity vars
  private offlineEvent: Observable<Event> | undefined;
  private onlineEvent: Observable<Event> | undefined;
  private subscriptions: Subscription[] = [];

  private handleAppConnectivityChanges(): void {
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      // handle online mode
      console.log('Online...');
      this.appNotificationService.notification$.next({message: translate('notifications.connectionOnline'), style:"success"})
      this._connectionState$.next(true)

    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      // handle offline mode
      console.log('Offline...');
      this.appNotificationService.notification$.next({message: translate('notifications.connectionOffline'), style:"error"})
      this._connectionState$.next(false)
    }));

    //set inital value
    this._connectionState$.next(window.navigator.onLine)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
